import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { IReckonHotelEffects } from './integrated-ireckon-hotel.effects';
import { integratedIReckonHotelReducer } from './integrated-ireckon-hotel.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('integratedIReckonHotel', integratedIReckonHotelReducer),
    EffectsModule.forFeature([IReckonHotelEffects]),
  ],
  providers: [],
})
export class IntegratedIReckonHotelStoreModule {}
